import { RefundApplicationTableHeader } from './RefundApplicationTableHeader';
import { RefundApplicationTableRow } from './RefundApplicationTableRow';
import { TransactionApplicationTableProps } from './TransactionApplicationTable';
import { TransactionApplicationTableLayout } from './TransactionApplicationTableLayout';
import { useTransactionApplicationSelection } from './useTransactionApplicationSelection';

// Refund variant drops the Amount Due and Status columns (5 cells total).
const REFUND_TABLE_GRID_TEMPLATE_COLUMNS =
  'minmax(auto, 1.25rem) minmax(8rem, auto) repeat(2, minmax(auto, 1fr)) minmax(auto, 8rem)';

// "Apply All" spans every cell after the checkbox: invoice + 3 data columns.
const REFUND_APPLY_ALL_COL_SPAN = 4;

/**
 * Table used by the refund flow. Composes the same layout and selection logic
 * as {@link TransactionApplicationTable} but renders the refund header and rows,
 * which omit the Amount Due and Status columns.
 */
export const RefundApplicationTable = ({
  sourceType,
  totalAvailableAmount,
  formState,
  availableAmount,
  isDisabled = false,
}: TransactionApplicationTableProps) => {
  const { checkedState, rows, handleToggleSelectAll } =
    useTransactionApplicationSelection({ formState, totalAvailableAmount });

  return (
    <TransactionApplicationTableLayout
      gridTemplateColumns={REFUND_TABLE_GRID_TEMPLATE_COLUMNS}
      applyAllColSpan={REFUND_APPLY_ALL_COL_SPAN}
      header={<RefundApplicationTableHeader sourceType={sourceType} />}
      checkedState={checkedState}
      isDisabled={isDisabled}
      onToggleSelectAll={handleToggleSelectAll}
    >
      {rows.map((row, i) => (
        <RefundApplicationTableRow
          key={i}
          index={i}
          row={row}
          formState={formState}
          isDisabled={isDisabled}
          availableAmount={availableAmount}
        />
      ))}
    </TransactionApplicationTableLayout>
  );
};
